export default "__VITE_ASSET__3f2e4cd0__"